require('./bootstrap');

import Router from "./utils/Router";

import common from "./routes/common";

import admins_index from "./routes/admins/index";

import advices_calc from "./routes/advices/calc";
import costs_calc from "./routes/costs/calc";
import purchases_calc from "./routes/purchases/calc";

import interacts_with_payments from "./routes/payments/interacts_with_payments";

import accounting_costs from "./routes/accounting/costs";
import accounting_credits from "./routes/accounting/credits";
import accounting_debits from "./routes/accounting/debits";

import purchasing_channels_create from "./routes/purchasing_channels/create";
import purchasing_channels_edit from "./routes/purchasing_channels/edit";

import sales_channels_create from "./routes/sales_channels/create";
import sales_channels_edit from "./routes/sales_channels/edit";

import warehouses_show from "./routes/warehouses/show";
import transport_documents_edit from "./routes/transport_documents/edit";
import invoices_edit from "./routes/invoices/edit";

import dashboard_show from "./routes/dashboard/show";

const routes = new Router({
    common,
    admins_index,
    advices_calc,
    costs_calc,
    purchases_calc,
    interacts_with_payments,
    accounting_costs,
    accounting_credits,
    accounting_debits,
    purchasing_channels_create,
    purchasing_channels_edit,
    sales_channels_create,
    sales_channels_edit,
    warehouses_show,
    transport_documents_edit,
    invoices_edit,
    dashboard_show,
});

$(document).ready(() => {
    routes.loadEvents();
});
